import { makeStyles,useTheme } from '@material-ui/core/styles';

const useStyles = makeStyles(theme =>({
  panelTitle: {
    fontSize: '15px',
    fontWeight: 'bold',
    lineHeight: '18px'
  },
  formPanel: {
    paddingTop: '30px',
    paddingLeft: '220px',
    [theme.breakpoints.down('sm')]:{
      paddingLeft: '20px',
      flexDirection: 'column',
      display: 'flex',
      paddingBottom: '50px'
    }
  },
  inputFields: {
    display: 'flex',
    flexDirection: 'row',
    paddingTop: '30px',
    paddingBottom: '30px',
    [theme.breakpoints.down('sm')]:{
      flexDirection: 'column',
      display: 'flex',
      width: '80%',
    }
  },
  photoUpload: {
    width: '285px'
  },
  photoError: {
    marginBottom: 0
  },
  colorPaletteWrapper: {
    width: '285px',
    marginLeft: '30px',
    [theme.breakpoints.down('sm')]:{
      width: '85px',
      marginLeft: '0px',
      marginTop: '20px'
    }
  },
  colorPalette: {
    position: 'relative',
    width: '285px',
    height: '204px',
    borderRadius: '3px',
    backgroundColor: '#E5E5E5'
  },
  editIconWrapper: {
    position: 'absolute',
    bottom: '0',
    right: '0',
    '&:hover': {
      cursor: 'pointer'
    },
    background: '#464646',
    height: '24px',
    [theme.breakpoints.down('sm')]:{
      height: '50px',
      width: '50px'
     
   }

  },
  editIcon: {
    color: 'white',
    fontSize: '16px',
    padding: '4px',
    [theme.breakpoints.down('sm')]:{
      height: '50px',
      width: '50px'
     
   }
    
  },
  unitSelectWrapper: {
    paddingTop: '30px'
  },
  languagesSelect: {
    display: 'block',
    width: '100%'
  },
  inputWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    paddingBottom: '30px',
    [theme.breakpoints.down('sm')]:{
      flexDirection: 'column',
      display: 'flex',
      width: '100%',
      
    }
  },
  input: {
    width: '45%',
    [theme.breakpoints.down('sm')]:{
      paddingBottom: '20px',
      width: '100%',
      paddingRight: '10px'
    }
  }
}));

export default useStyles;
